export default __webpack_public_path__ + "static/media/settings.8d65c07d.svg";